import { render, staticRenderFns } from "./wlmz-biz-detail.vue?vue&type=template&id=dbd8bbf0&scoped=true&"
import script from "./wlmz-biz-detail.vue?vue&type=script&lang=js&"
export * from "./wlmz-biz-detail.vue?vue&type=script&lang=js&"
import style0 from "./wlmz-biz-detail.vue?vue&type=style&index=0&id=dbd8bbf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd8bbf0",
  null
  
)

export default component.exports